var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup46(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.016,
    height: 133.321,
    viewBox: "0 0 108.016 133.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(53.694 -1829.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1058.678,962.914H1051.1a5.673,5.673,0,0,1-5.674-5.674v-36.6a5.674,5.674,0,0,1,5.674-5.675h7.579a5.674,5.674,0,0,1,5.674,5.675v36.6a5.674,5.674,0,0,1-5.674,5.674",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1057.943,911.2h-6.109a2.511,2.511,0,0,1-2.511-2.511V868.055a2.511,2.511,0,0,1,2.511-2.511h6.109a2.511,2.511,0,0,1,2.511,2.511v40.637a2.511,2.511,0,0,1-2.511,2.511",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1081.985,850.709V840.428a3,3,0,0,1,3-3h5.089a3,3,0,0,1,3,3v10.281a3,3,0,0,1-3,3h-5.089a3,3,0,0,1-3-3",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1070.955,861.542h-32.133a7.764,7.764,0,0,1-7.764-7.764v-16.42a7.765,7.765,0,0,1,7.764-7.765h32.133a7.765,7.765,0,0,1,7.764,7.765v16.42a7.764,7.764,0,0,1-7.764,7.764",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1106.1,861.9h-5.429a4.344,4.344,0,0,1-4.343-4.343v-22.79a4.343,4.343,0,0,1,4.343-4.343h5.429a4.342,4.342,0,0,1,4.343,4.343v22.79a4.343,4.343,0,0,1-4.343,4.343",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1026.843,842.685v-4a24.727,24.727,0,0,0-24.258,19.35,6.136,6.136,0,0,0,11.956,2.77,12.673,12.673,0,0,1,12.3-9.85v-8.27Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup46);
export default __webpack_public_path__ + "static/media/Group 46.7110a4692f06077373827a725921564a.svg";
export { ForwardRef as ReactComponent };